if (!customElements.get("ac-vertical-gallery")) {
  class AcVerticalGallery extends HTMLElement {
    connectedCallback() {
      const stickyBox = this.querySelector(".vertical-gallery__content-box");
      const images = this.querySelectorAll(".vertical-gallery__image");
      const items = this.querySelectorAll(".vertical-gallery__content-item");
      this._stickyHighlighter = new StickyHighlighter(stickyBox, images, {
        activeClass: "vertical-gallery__image--active",
        debounceTime: 100,
        onActiveChange: (index) => {
          if (index >= 0 && items[index]) {
            items.forEach((item) => item.classList.remove("vertical-gallery__content-item--active"));
            items[index].classList.add("vertical-gallery__content-item--active");
          }
        }
      });
    }
  }
  customElements.define("ac-vertical-gallery", AcVerticalGallery);
}
